<template>
  <TemplateView>
    <div class="container">
      <TemplatePageGrid
        :items="workExtraTypeGrid"
        :page-data="pageData"
        :loading="loadingAnimation"
        sort-az="last_name"
      >
        <template v-slot:buttons>
          <WorkExtraTypeModal
            v-if="
              $userCheckAccess({
                abilities: 'edit_work_extra_types',
              })
            "
            :create="true"
          />
        </template>
        <WorkExtraTypeTable :items="workExtraTypeGrid" />
      </TemplatePageGrid>
    </div>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import TemplateView from 'components/templates/TemplateView'
import TemplatePageGrid from 'components/templates/TemplatePageGrid'
import WorkExtraTypeTable from 'components/setting/workExtraType/WorkExtraTypeTable'
import WorkExtraTypeModal from 'components/setting/workExtraType/WorkExtraTypeModal'

export default {
  name: 'WorkExtraType',
  components: {
    TemplateView,
    TemplatePageGrid,
    WorkExtraTypeTable,
    WorkExtraTypeModal,
  },
  data() {
    return {}
  },
  created() {
    this.downloadPageData()
  },
  watch: {
    '$route.query'() {
      this.downloadPageData()
    },
  },
  computed: {
    ...mapGetters('workExtraType', ['workExtraTypeGrid', 'pageData']),
    ...mapGetters(['loadingAnimation']),
  },
  methods: {
    ...mapActions('workExtraType', ['onWorkExtraTypeGrid']),
    downloadPageData() {
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      this.onWorkExtraTypeGrid(data)
    },
  },
}
</script>
